import {FormPageLayout} from "../../components/layout/FormPageLayout";
import {PostListFeature} from "../../features/postList";

const PostListPage = () => (
  <FormPageLayout
    body={
      <PostListFeature />
    }
  />
)

export default PostListPage;
